<template>
<b-container class="directory-listings">
  <slot></slot>
  <section class="grid"
           :class="{'dense':dense}"
           v-if="items && items.length > 0">
    <PostItem v-for="(item, i) in items"
              :key="i"
              :clean="clean"
              :simple="simple"
              :item="item" />

  </section>

  <b-alert show
           variant="warning"
           v-else-if="items.length == 0">
    0 results found
  </b-alert>

  <b-spinner v-else />
  <section class="pagination">
    <b-pagination
        v-model="localPage"
        :total-rows="totalRows"
        :per-page="perPage"
        @input="$emit('page-change', localPage)"
    ></b-pagination>

<!--    <lable>Per Page:</lable>-->
<!--    <b-form-select-->
<!--        v-model="localPageSize"-->
<!--        :options="pageSizeOptions"-->
<!--        size="md"-->
<!--        class="mt-2 w-auto"-->
<!--        @change="$emit('page-size-change', localPageSize)">-->
<!--      <b-select-option value="10">10</b-select-option>-->
<!--      <b-select-option value="25">25</b-select-option>-->
<!--      <b-select-option value="50">50</b-select-option>-->
<!--      <b-select-option value="100">100</b-select-option>-->
<!--    </b-form-select>-->
  </section>
</b-container>
</template>
<script>
import PostItem from "@/components/ui/PostItem"
export default {
  name: 'DirectoryListings',
  components: {
    PostItem
  },
  props: {
    'totalRows': Number,
    'perPage': Number,
    'items': Array,
    'currentPage': {
      type: Number,
      default: 1,
    },
    'clean': {
      type: Boolean,
      default: false
    },
    'dense': {
      type: Boolean,
      default: false
    },
    'simple': {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      localPage: this.currentPage,
    }
  },
  watch:{
    currentPage(newVal){
      this.localPage = newVal;
    }
  }
}
</script>
<style scoped lang="scss">
.directory-listings {
  .grid {
    display: grid;
    grid-gap: 2rem;

    .mobile & {
      grid-template-columns: 1fr;
    }

    .desktop &,
    .tablet & {
      grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
    }

    &.dense {
      grid-auto-flow: row dense;
    }
  }

  .pagination {
    display: flex;
    justify-content: center;  /* center horizontally */
    align-items: center;      /* center vertically */
    padding: 1rem 0;          /* top/bottom padding */

    .b-pagination {
      margin: 0;              /* remove default margins */
    }

    .form-select {
      width: auto;            /* shrink select to content width */
    }
  }
}
</style>

